import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { HBox, VBox } from '../../../components/Box';
import { Checkbox } from '../../../components/Checkbox';
import { selectInvoice } from '../../Invoices/selectors';
import { getDate } from '../helpers';
import { getPropByName } from '../../../utils/props';
import { selectAddressTypes } from '../../Address/selectors';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { formatLicensePlate } from '../../../utils/string';
import { AlignRight } from 'react-feather';

const Container = styled.div`
  font-family: 'Nunito', sans-serif;
  line-height: normal;
  padding-top: 130px;
  width: 100%;
  max-width: 1240px;
  background-color: white;
  color: black;
  font-size: 20px; /* Sets base font size for all text elements */

  /* Reset font size for specific elements */
  span, div, li, ol, ul, pre, h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
  }


  pre {
    white-space: pre-line;
    font-family: 'Nunito', sans-serif;
  }

  .title {
    margin-bottom: 24px;
    font-size: 45px;
    text-decoration: underline;
  }

  .vehicle-property-wrap {
    width: 80%;
  }
`;




const STATE = {};
let city = '';
let company_name = 'company not found';
if (env.clientId === AppClientId.HARRY_NIJBOER) {
  company_name = 'Autobedrijf Harry Nijboer B.V.';
  city = 'Lemelerveld';
} else if (env.clientId === AppClientId.AUTOWIENTJES) {
  company_name = 'Auto Wientjes B.V.';
  city = 'Apeldoorn';
} else if (env.clientId === AppClientId.AUTOHUISSALLAND) {
  company_name = 'Autohuis Salland';
  city = 'Lemelerveld';
}

/* eslint-disable react/prefer-stateless-function */
class PickUpStatementDocComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get outgoingCompany() {
    return this.props.invoice?.outgoingCompany;
  }

  get homeAddress() {
    const homeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;

    const homeAddress = this.outgoingCompany?.addresses.find(address => address?.type?.id == homeId);

    return homeAddress;
  }

  renderNL(vehicle, invoice) {
    return (
      <>
        <HBox center>
          <VBox>
            <h1 style={{ textAlign: 'center', marginLeft: '90px' }} className="title">
            Vervoersverklaring
            </h1>
          </VBox>
          <VBox>
            <div style={{ marginLeft: '150px', fontSize: '20px' }}>Factuurnummer: &nbsp;{invoice?.entryNumber ?? ''}</div>
            <div style={{ marginLeft: '150px', fontSize: '20px' }}>
              {' '}
              Factuurdatum:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{getDate(invoice?.date) ?? 'date'}
            </div>
          </VBox>
        </HBox>

        <VBox left style={{ marginLeft: '90px', fontSize: '22px', maxWidth: '90%' }}>
          <VBox style={{ marginBottom: '30px', fontSize: '20px'  }}>
            <span>Ondergetekende: </span>
            <span style={{ opacity: '0.2' , fontSize: '20px' }}>(Naam van degene die de goederen in ontvangst neemt)</span>
          </VBox>
          <span>Verklaart namens de afnemer:</span>
          <VBox left style={{ marginLeft: '50px', marginBottom: '50px', maxWidth: '90%' , fontSize: '20px' }}>
            <ol style={{ width: '100%' }}>
              <li>
                Dat het voertuig:
                <HBox className="vehicle-property-wrap">
                  <span>Merk: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{vehicle?.brand_name ?? ''}</strong>
                  </HBox>
                </HBox>
                <HBox className="vehicle-property-wrap">
                  <span>Model: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{vehicle?.model_name ?? ''}</strong>
                  </HBox>
                </HBox>
                <HBox className="vehicle-property-wrap">
                  <span>Kenteken: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{formatLicensePlate(vehicle?.regplate) ?? ''}</strong>
                  </HBox>
                </HBox>
                <HBox className="vehicle-property-wrap">
                  <span>Chassisnummer: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{vehicle?.vin ?? ''}</strong>
                  </HBox>
                </HBox>
                <pre  style={{ fontSize: '20px'}}>
                  {`die staat vermeld op de door  `} {company_name} {`  afgegeven factuur met nummer `}
                  <strong>
                    {vehicle?.outgoing_invoice_generated &&
                      (invoice?.entryNumber ?? '') + ' d.d. ' + (getDate(invoice?.date) ?? 'date')}
                  </strong>
                </pre>
                <VBox >
                 <span style={{ fontSize: '20px'}}>Is geleverd aan de volgende afnemer:</span>
                  {vehicle?.outgoing_invoice_generated ? (
                    <>
                      <strong>
                        {getPropByName(this.outgoingCompany, 'name') ?? ''}&nbsp;
                        {getPropByName(this.outgoingCompany, 'surname') ?? ''}
                      </strong>
                      <strong>{this.homeAddress?.addressLine1}</strong>
                      <strong>
                        {this.homeAddress?.postcode}&nbsp;{this.homeAddress?.city}
                      </strong>
                      <strong>{this.homeAddress?.country?.name}</strong>
                      <strong>{this.outgoingCompany?.BTW_number}</strong>
                    </>
                  ) : (
                    <>
                      <br />
                      <br />
                      <br />
                      <br />
                    </>
                  )}
                </VBox>
              </li>
              <li>
                <pre>
                  {`Dat bovenstaande auto is gekocht van  `} {company_name}{' '}
                  {`  en het eigendom wordt overgedragen aan bovenstaande afnemer.`}
                </pre>
              </li>
              <li style={{fontSize: '20px'}}>
                <pre>{`Dat bovenstaande auto zal worden vervoerd naar bovenstaand adres door middel van
                (aanvinken wat van toepassing is):`}</pre>
                <HBox left vCenter>
                  <Checkbox checked={false}/><span style={{fontSize: '18px'}}>Transportvoertuig met kenteken:{' '}</span> 
                  <HBox style={{ width: '160px', height: '12px', borderBottom: '1px dotted black', fontSize: '20px' }}></HBox>
                </HBox>
                <HBox left vCenter>
                  <Checkbox checked={false} /> <span style={{fontSize: '18px'}}>Persoonlijk afgehaald door ondergetekende (kopie ID-bewijs toevoegen)</span>
                </HBox>
                <HBox left vCenter>
                  <Checkbox checked={false} /> <span style={{fontSize: '18px'}}>Zelf transport door Auto Wientjes</span>
                </HBox>
              </li>

              <li>
                <pre>{`Dat het bovenstaande voertuig definitief geregistreerd wordt in het land van facturatie.`}</pre>
              </li>
              <li>
                <pre>
                  {`Dat de afnemer de door  `} {company_name} {`  geleverde auto in ontvangst heeft genomen.`}
                </pre>
              </li>
              <li>
                <pre>
                  {`Dat de klant bereid is door ondertekening van deze verklaring om meer informatie en documentatie te overleggen voor de Belastingdienst aan `}{' '}
                  {company_name}{' '}
                  {` over de bestemming van de auto(‘s) voor zover al niet verstrekt, zoals de CMR brief, transport factuur, verklaring van de magazijnhouder of het garagebedrijf, conform de bepalingen van de EU Quick fixes regels. De opgevraagde informatie en documentatie zal volledig aan  `}{' '}
                  {company_name} {`  worden overhandigd binnen 7 dagen vanaf de verzoekdatum.`}
                </pre>
              </li>
              <li>
                <pre>{`Dat de klant voorts zelf zorg dient te dragen voor een verzekering.`}</pre>
              </li>
              <li>
                <pre>{`Dat alle risico's en aansprakelijkheden vanaf het moment van verkoop zijn overgedragen aan de afnemer`}</pre>
              </li>
              <li>
                <pre>
                  {`Dat de afnemer`} {company_name}{' '}
                  {`toestemming geeft zijn/haar gegevens op te slaan en te verwerken in haar administratie zoals te lezen is in `}{' '}
                  {company_name} {`’s privacy statement.`}
                </pre>
              </li>
            </ol>
          </VBox>
          <VBox>
            <HBox style={{ width: '85%' }}>
              <span style={{fontSize: '20px'}}>Plaats:</span>
              <span style={{fontSize: '20px'}}>Datum:</span>
            </HBox>
            <HBox style={{ width: '85%', marginBottom: '50px' }}>
              <strong style={{fontSize: '20px'}}>{city}</strong>
              <strong style={{fontSize: '20px'}}></strong>
            </HBox>
            <VBox style={{ marginBottom: '50px' }}>
              <span style={{fontSize: '20px'}}>Handtekening ondergetekende:</span>
            </VBox>
            <HBox style={{ width: '160px', borderBottom: '1px dotted black' }}></HBox>
          </VBox>
        </VBox>
      </>
    );
  }

  renderDE(vehicle, invoice) {
    return (
      <>
        <HBox center>
          <VBox>
            <h1 style={{ textAlign: 'center', marginLeft: '90px' }} className="title">
            Transporterklärung
            </h1>
          </VBox>
          <VBox>
            <div style={{ marginLeft: '150px', fontSize: '20px' }}>
              Rechnung nummer:&nbsp;&nbsp;{invoice?.entryNumber ?? ''}
            </div>
            <div style={{ marginLeft: '150px', fontSize: '20px' }}>
              {' '}
              Rechnung datum:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{getDate(invoice?.date) ?? 'date'}
            </div>
          </VBox>
        </HBox>

        <VBox left style={{ marginLeft: '90px', fontSize: '22px', maxWidth: '90%' }}>
          <VBox style={{ marginBottom: '30px' }}>
            <span>Unterzeichnet: </span>
            <span style={{ opacity: '0.2' }}>(Name der Person, die das Auto erhält)</span>
          </VBox>
          <span>Erklärt im Namen des Kunden:</span>
          <VBox left style={{ marginLeft: '50px', marginBottom: '50px', maxWidth: '90%' }}>
            <ol style={{ width: '100%' }}>
              <li>
                Dass das Fahrzeug:
                <HBox className="vehicle-property-wrap">
                  <span>Marke: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{vehicle?.brand_name ?? ''}</strong>
                  </HBox>
                </HBox>
                <HBox className="vehicle-property-wrap">
                  <span>Modell: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{vehicle?.model_name ?? ''}</strong>
                  </HBox>
                </HBox>
                <HBox className="vehicle-property-wrap">
                  <span>Kennzeichen: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{formatLicensePlate(vehicle?.regplate) ?? ''}</strong>
                  </HBox>
                </HBox>
                <HBox className="vehicle-property-wrap">
                  <span>Fahrgestellnummer: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{vehicle?.vin ?? ''}</strong>
                  </HBox>
                </HBox>
                <pre>
                  {`Die auf der von  `} {company_name} {`  ausgestellten Rechnung mit der Nummer `}{' '}
                  {`  ausgestellten Rechnung mit der Nummer `}
                  <strong>
                    {vehicle?.outgoing_invoice_generated &&
                      (invoice?.entryNumber ?? '') + ' und dem Datum ' + (getDate(invoice?.date) ?? 'date')}
                  </strong>
                </pre>
                <VBox>
                  Wurde an folgenden Kunden geliefert:
                  {vehicle?.outgoing_invoice_generated ? (
                    <>
                      <strong>
                        {getPropByName(this.outgoingCompany, 'name') ?? ''}&nbsp;
                        {getPropByName(this.outgoingCompany, 'surname') ?? ''}
                      </strong>
                      <strong>{this.homeAddress?.addressLine1}</strong>
                      <strong>
                        {this.homeAddress?.postcode}&nbsp;{this.homeAddress?.city}
                      </strong>
                      <strong>{this.homeAddress?.country?.name}</strong>
                      <strong>{this.outgoingCompany?.BTW_number}</strong>
                    </>
                  ) : (
                    <>
                      <br />
                      <br />
                      <br />
                      <br />
                    </>
                  )}
                </VBox>
              </li>
              <li>
                <pre>
                  {`Dass das oben genannte Auto von  `} {company_name}{' '}
                  {`  gekauft wurde und das Eigentum auf den oben genannten Kunden übergeht.`}
                </pre>
              </li>
              <li>
                <pre>{`Dass das oben genannte Auto an die oben genannte Adresse transportiert wird mit:`}</pre>
                <HBox left vCenter>
                  <Checkbox checked={false} /> Transportfahrzeug mit Kennzeichen:{' '}
                  <HBox style={{ width: '160px', height: '12px', borderBottom: '1px dotted black' }}></HBox>
                </HBox>
                <HBox left vCenter>
                  <Checkbox checked={false} /> Vom Unterzeichner persönlich abgeholt (Kopie des Personalausweises beifügen)
                </HBox>
                <HBox left vCenter>
                  <Checkbox checked={false} /> Eigentransport durch Auto Wientjes
                </HBox>
              </li>
              <li>
                <pre>{`Dass das oben genannte Fahrzeug im Rechnungsland endgültig zugelassen ist.`}</pre>
              </li>
              <li>
                <pre>
                  {`Dass der Kunde das von  `} {company_name} {`  gelieferte Auto erhalten hat.`}
                </pre>
              </li>
              <li>
                <pre>
                  {`Mit der Unterzeichnung dieser Erklärung ist der Kunde bereit, der `} {company_name}{' '}
                  {` weitere Informationen und Unterlagen für die Steuerbehörden über den Bestimmungsort des/der Fahrzeug(s) zur Verfügung zu stellen, sofern diese nicht bereits bereitgestellt wurden, wie z. B. das CMR-Brief, die Transportrechnung, die Erklärung des Lagerbesitzer oder das Werkstattunternehmen gemäß den Bestimmungen der EU-Schnellreparaturvorschriften. Die angeforderten Informationen und Unterlagen werden`}{' '}
                  {company_name} {`innerhalb von 7 Tagen ab dem Anfragedatum vollständig zur Verfügung gestellt.`}
                </pre>
              </li>
              <li>
                <pre>{`Dass der Kunde auch selbst für eine Versicherung sorgen muss.`}</pre>
              </li>
              <li>
                <pre>{`Dass alle Risiken und Verbindlichkeiten ab dem Zeitpunkt des Verkaufs auf den Käufer übergegangen sind.`}</pre>
              </li>
              <li>
                <pre>
                  {`Dass der Kunde  `} {company_name}{' '}
                  {`  die Erlaubnis gibt, seine Daten in der Verwaltung zu speichern und zu verarbeiten, wie in der Datenschutzerklärung von  `}{' '}
                  {company_name} {`  nachzulesen ist.`}
                </pre>
              </li>
            </ol>
          </VBox>
          <VBox>
            <HBox style={{ width: '85%' }}>
              <span>Ort:</span>
              <span>Datum:</span>
            </HBox>
            <HBox style={{ width: '85%', marginBottom: '50px' }}>
              <strong>{city}</strong>
              <strong></strong>
            </HBox>
            <VBox style={{ marginBottom: '50px' }}>
              <span>Unterschrift des Unterzeichnet:</span>
            </VBox>
            <HBox style={{ width: '160px', borderBottom: '1px dotted black' }}></HBox>
          </VBox>
        </VBox>
      </>
    );
  }

  renderEN(vehicle, invoice) {
    return (
      <>
        <HBox center>
          <VBox>
            <h1 style={{ textAlign: 'center', marginLeft: '90px' }} className="title">
            Transport declaration
            </h1>
          </VBox>
          <VBox>
            <div style={{ marginLeft: '150px', fontSize: '20px' }}>
              Invoice number:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{invoice?.entryNumber ?? ''}
            </div>
            <div style={{ marginLeft: '150px', fontSize: '20px' }}>
              {' '}
              Invoice date:&nbsp;&nbsp;{getDate(invoice?.date) ?? 'date'}
            </div>
          </VBox>
        </HBox>

        <VBox left style={{ marginLeft: '90px', fontSize: '22px', maxWidth: '90%' }}>
          <VBox style={{ marginBottom: '30px' }}>
            <span>Undersigned: </span>
            <span style={{ opacity: '0.2' }}>(Name of person receiving the goods)</span>
          </VBox>
          <span>Declares on behalf of the customer:</span>
          <VBox left style={{ marginLeft: '50px', marginBottom: '50px', maxWidth: '90%' }}>
            <ol style={{ width: '100%' }}>
              <li>
                That the vehicle:
                <HBox className="vehicle-property-wrap">
                  <span>Brand: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{vehicle?.brand_name ?? ''}</strong>
                  </HBox>
                </HBox>
                <HBox className="vehicle-property-wrap">
                  <span>Modell: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{vehicle?.model_name ?? ''}</strong>
                  </HBox>
                </HBox>
                <HBox className="vehicle-property-wrap">
                  <span>License plate: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{formatLicensePlate(vehicle?.regplate) ?? ''}</strong>
                  </HBox>
                </HBox>
                <HBox className="vehicle-property-wrap">
                  <span>Chassis number: </span>
                  <HBox left style={{ width: '50%' }}>
                    <strong>{vehicle?.vin ?? ''}</strong>
                  </HBox>
                </HBox>
                <pre>
                  {`Which is stated on the invoice issued by  `} {company_name} {`  with number `}
                  <strong>
                    {vehicle?.outgoing_invoice_generated &&
                      (invoice?.entryNumber ?? '') + ' dated ' + (getDate(invoice?.date) ?? 'date')}
                  </strong>
                </pre>
                <VBox>
                  Has been delivered to the following customer:
                  {vehicle?.outgoing_invoice_generated ? (
                    <>
                      <strong>
                        {getPropByName(this.outgoingCompany, 'name') ?? ''}&nbsp;
                        {getPropByName(this.outgoingCompany, 'surname') ?? ''}
                      </strong>
                      <strong>{this.homeAddress?.addressLine1}</strong>
                      <strong>
                        {this.homeAddress?.postcode}&nbsp;{this.homeAddress?.city}
                      </strong>
                      <strong>{this.homeAddress?.country?.name}</strong>
                      <strong>{this.outgoingCompany?.BTW_number}</strong>
                    </>
                  ) : (
                    <>
                      <br />
                      <br />
                      <br />
                      <br />
                    </>
                  )}
                </VBox>
              </li>
              <li>
                <pre>
                  {`That the above car was purchased from  `} {company_name}{' '}
                  {`  and the ownership is transferred to the above customer.`}
                </pre>
              </li>
              <li>
                <pre>{`That the above car will be transported to the above address by means of:`}</pre>
                <HBox left vCenter>
                  <Checkbox checked={false} /> Transport vehicle with licence plate number:{' '}
                  <HBox style={{ width: '160px', height: '12px', borderBottom: '1px dotted black' }}></HBox>
                </HBox>
                <HBox left vCenter>
                  <Checkbox checked={false} /> Personally collected by the undersigned (add a copy of ID)
                </HBox>
                <HBox left vCenter>
                  <Checkbox checked={false} /> Transport by Auto Wientjes
                </HBox>
              </li>
              <li>
                <pre>{`That the above vehicle is definitively registered in the billing country.`}</pre>
              </li>
              <li>
                <pre>
                  {`That the customer has received the car delivered by  `} {company_name} {` .`}
                </pre>
              </li>
              <li>
                <pre>
                  {`By signing this statement, the customer is prepared to provide more information and documentation for the tax authorities to  `}{' '}
                  {company_name}{' '}
                  {`  about the destination of the car(s) insofar as not already provided, such as the CMR letter, transport invoice, statement of the warehouse owner or the garage company, in accordance with the provisions of the EU Quick fixes rules. The requested information and documentation will be provided in full to  `}{' '}
                  {company_name} {`  within 7 days from the request date.`}
                </pre>
              </li>
              <li>
                <pre>{`That the customer must also arrange his own insurance.`}</pre>
              </li>
              <li>
                <pre>{`That all risks and liabilities have been transferred to the buyer from the moment of sale.`}</pre>
              </li>
              <li>
                <pre>
                  {`That the customer gives  `} {company_name}{' '}
                  {`  permission to store and process his/her data in its administration, as can be read in  `}{' '}
                  {company_name} {` 's privacy statement.`}
                </pre>
              </li>
            </ol>
          </VBox>
          <VBox>
            <HBox style={{ width: '85%' }}>
              <span>Place:</span>
              <span>Date:</span>
            </HBox>
            <HBox style={{ width: '85%', marginBottom: '50px' }}>
              <strong>{city}</strong>
              <strong></strong>
            </HBox>
            <VBox style={{ marginBottom: '50px' }}>
              <span>Signature of the undersigned:</span>
            </VBox>
            <HBox style={{ width: '160px', borderBottom: '1px dotted black' }}></HBox>
          </VBox>
        </VBox>
      </>
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const invoice = this.props.invoice;

    return (
      <Container>
        {this.props.language == 'nl' && this.renderNL(vehicle, invoice)}
        {this.props.language == 'de' && this.renderDE(vehicle, invoice)}
        {this.props.language == 'en' && this.renderEN(vehicle, invoice)}
      </Container>
    );
  }
}

PickUpStatementDocComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.outgoingInvoiceId),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PickUpStatementDoc = compose(withConnect, withRouter)(PickUpStatementDocComp);
